import React from "react";
import "./countUp.style.sass";
import { Alert, Col, Row } from "rsuite";
import CountUp from "react-countup";
import VisibilitySensor from "react-visibility-sensor";
import Axios from "axios";
import { connect } from "react-redux";
import { createStructuredSelector } from "reselect";
import { selectCountUp } from "../../redux/site/site.selector";
import { SetCountUp } from "../../redux/site/site.actions";
import { css } from "@emotion/react";
import PuffLoader from "react-spinners/PuffLoader";
import { Setting } from "../../setting";

class CountUpComponent extends React.Component {
  state = {
    appear: false,
  };

  componentDidMount() {
    const { setCountUpData } = this.props;
    Axios.get(`${Setting.apiUrl}api/statics`).then((res) => {
      if (res.status === 200) {
        setCountUpData(res.data);
      } else {
        Alert.error(
          "مشکلی در بارگذاری برخی دیتا ها بوجود آمده لطفا از اتصال خود به اینترنت مطمئن شوید و صفحه را تازه‌سازی نمایید",
          5000
        );
      }
    });
  }

  visibleChangeHandler = (isVisible) => {
    if (isVisible) {
      this.setState({
        appear: true,
      });
    }
  };

  render() {
    const override = css`
      display: block;
      margin: 40px auto;
      border-color: red;
    `;
    const arry = [1, 2, 3, 4];
    const { selectCountUp } = this.props;
    return (
      <div className="count-up">
        <div className="count-container">
          <Row>
            {selectCountUp
              ? selectCountUp.map((item) => (
                  <Col key={item.id} md={6} sm={12} xs={24}>
                    <div className="count-content">
                      <h3>
                        <CountUp
                          end={parseInt(item.end)}
                          start={this.state.appear ? 0 : null}
                          duration={8}
                          delay={0.2}
                        >
                          {({ countUpRef }) => (
                            <div>
                              <span ref={countUpRef} />
                              <VisibilitySensor
                                onChange={(isVisible) =>
                                  this.visibleChangeHandler(isVisible)
                                }
                              >
                                <span>{item.id > 3 ? "%" : " +"}</span>
                              </VisibilitySensor>
                            </div>
                          )}
                        </CountUp>
                      </h3>
                      <h6>{item.text}</h6>
                    </div>
                  </Col>
                ))
              : arry.map((item) => (
                  <Col key={item} md={6} sm={12} xs={24}>
                    <PuffLoader
                      color="#FF8F3C"
                      loading={true}
                      css={override}
                      size={60}
                    />
                  </Col>
                ))}
          </Row>
        </div>
      </div>
    );
  }
}

const mapStateToProps = createStructuredSelector({
  selectCountUp: selectCountUp,
});
const mapDispatchToProps = (dispatch) => ({
  setCountUpData: (data) => dispatch(SetCountUp(data)),
});
export default connect(mapStateToProps, mapDispatchToProps)(CountUpComponent);
